/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    const module = this;

    const Settings = {
        global: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            centeredSlides: true,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },

        hologram: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            centeredSlides: true,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            custom: {
                hurtBalls: null,
                introBallsEl: null,
                clickedBall: null,
                currentBall: null,
                activeDesktopFlag: false,
                toggleActiveElement: function (swiper) {
                    swiper.params.custom.clickedBall = swiper.params.custom.hurtBalls[swiper.activeIndex];

                    if (swiper.params.custom.currentBall) {
                        swiper.params.custom.currentBall.classList.remove("js-active");
                    }

                    swiper.params.custom.clickedBall.classList.add("js-active");
                    swiper.params.custom.currentBall = swiper.params.custom.clickedBall;

                    if (!swiper.params.custom.introBallsEl.classList.contains("js-active")) {
                        swiper.params.custom.introBallsEl.classList.add("js-active");
                    }
                }
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name") || swiperContainer.closest(".js-slider").getAttribute("data-slider-settings");
                    const introCloseButton = document.querySelector(".js-ball-close");
                    swiper.params.custom.hurtBalls = document.querySelectorAll(".js-hurt-ball");
                    swiper.params.custom.introBallsEl = document.querySelector(".js-balls");
                    swiper.params.custom.currentBall = swiper.params.custom.hurtBalls[swiper.activeIndex];

                    Array.prototype.forEach.call(swiper.params.custom.hurtBalls, function (ball, index) {
                        ball.addEventListener("click", function (evt) {
                            evt.preventDefault();

                            if (index == swiper.activeIndex) {
                                swiper.params.custom.toggleActiveElement(swiper);
                                swiper.params.custom.activeDesktopFlag = true;
                            }

                            swiper.slideTo(index);
                        });
                    });

                    introCloseButton.addEventListener("click", function () {
                        swiper.params.custom.introBallsEl.classList.remove("js-active");
                        swiper.params.custom.currentBall.classList.remove("js-active");
                        swiper.params.custom.currentBall = null;
                    });
                },

                slideChange: function () {
                    const swiper = this;
                    swiper.params.custom.toggleActiveElement(swiper);
                }
            }
        },
    }

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    }

    module.getSettings = getSettings;
});